<template>
  <div class="background">
    <div class="wrapper">
      <SignInBox />
    </div>
  </div>
</template>

<script>
import SignInBox from "@/components/Auth/SignInBox.vue";
import { auth } from "@/firebase";
import { onBeforeMount } from "vue";
import { Routes } from "@/types/Routes";
import { useStore } from "vuex";

export default {
  name: "LogIn",
  components: {
    SignInBox,
  },
  setup() {
    const store = useStore();

    onBeforeMount(async () => {
      if (auth.currentUser) await store.dispatch("routeChecker", Routes.SIGNIN);
    });

    return {};
  },
};
</script>

<style scoped>
img {
  height: 75px;
}
.background {
  background-color: var(--background-blue);
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  flex-direction: column;
}
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-height: 75%;
}
</style>
